import React from "react";
import { Form, Input, Tooltip } from "antd";
import { get } from 'lodash';

const TextInput = ({
  values,
  errors,
  handleSubmit,
  setFieldValue,
  setFieldTouched,
  name,
  label,
  formItemLayout,
  placeholder,
  readOnly,
  disabled,
  callback,
  size,
  tooltip
}) => (
  <Form.Item label={tooltip ? <Tooltip placement='right' title={tooltip}>{label}</Tooltip> : label } {...formItemLayout}
    hasFeedback={!!get(errors,name)}
    validateStatus={get(errors,name) && "error"}
    help={get(errors,name)}
  >
    <Input
      size={size}
      placeholder={placeholder}
      value={get(values,name)}
      onChange={event => {
        setFieldValue(name, event.target.value);
      }}
      onBlur={() =>{ 
        setFieldTouched(name);
        if(callback){
          callback();
        }
      }}
      //onPressEnter={handleSubmit}
      readOnly={readOnly} disabled={disabled}
    />
  </Form.Item>
);

export default TextInput;
